import type { Faq } from "@components/Faq.js";
import type { Tenant } from "@core/schema/Tenant.js";

// import { getEmbeddedSoftwarePath } from "@core/schema/paths/getEmbeddedSoftwarePath.js";

export function getFaqsKiosks(tenant: Tenant): Faq[] {
	return [
		{
			question: "Proč se vyplatí nechat si vyvinout kioskové řešení na zakázku?",
			answer:
				"Vlastní kiosková aplikace vám pomůže zrychlit firemní procesy i růst podnikání, snížit náklady na personál nebo zlepšit celkový zážitek zákazníků z nákupu.",
		},
		{
			question: "Kolik stojí kioskové řešení na míru?",
			answer:
				"Každou zakázku naceňujeme individuálně podle jejího rozsahu, nicméně cena za vývoj kioskové aplikace se pohybuje zhruba od 200tis. do 500tis. Kč.",
		},
		{
			question: "Jak dlouho trvá vývoj softwaru pro kiosek?",
			answer: "Opět hodně záleží na rozsahu zakázky, ale většinou práce na vývoji zaberou zhruba 2–3 měsíce.",
		},
		{
			question: "Potřebujeme na míru vyvinout software pro jiný hardware než pro kiosek. Umíte to?",
			// TODO udělat proklik na "embedded software na zakázku" jakmile bude podstránka hotová
			answer: `Ano, zabýváme se také programováním embedded software na zakázku. Podle potřeby vám vytvoříme software téměř pro jakýkoliv hardware.`,
		},
		{
			question: "Které technologie můžete do kiosků integrovat?",
			answer:
				"Do kiosků můžeme integrovat dotykové displeje, tiskárny, platební terminály, čtečky čárových nebo QR kódů, kamery nebo třeba mikrofony.",
		},
		{
			question: "Pokud si od vás nechám dodat kompletní kiosek i s platebním terminálem, jaké platby bude podporovat?",
			answer:
				"Kiosek může podporovat platbu kartou, NFC (např. Apple Pay, Google Pay), ale i platbu pomocí QR kódu či hotovostí.",
		},
	];
}
